import {
  Button,
  FloatingTooltip,
  TooltipCore,
  VerticalStepper,
} from '@payaca/ambrosia';
import UntitledIcon, { TIconName } from '@payaca/untitled-icons';
import { FC } from 'react';

import useGetMyInboundEmailAddresses from '@/api/queries/inbound-emails/useGetMyInboundEmailAddresses';
import useCopyToClipboard from '@/hooks/useCopyToClipboard';

const CopyAddressButton: FC<{
  label: string;
  icon?: TIconName;
  address: string | undefined;
  tooltipText: string;
}> = (props) => {
  const { label, address, tooltipText, icon } = props;
  const { handleCopy } = useCopyToClipboard();

  return (
    <FloatingTooltip placement="top">
      <Button
        className="flex-1"
        colour="black"
        size="sm"
        variant="white"
        disabled={!address}
        onClick={() => address && handleCopy(address)}
      >
        {icon && <UntitledIcon name={icon} className="size-4" />} {label}
      </Button>
      <TooltipCore>{tooltipText}</TooltipCore>
    </FloatingTooltip>
  );
};

const InboxEmptyState: FC = () => {
  const { data } = useGetMyInboundEmailAddresses();
  const addresses = data?.me?.inboundEmailAddresses;

  return (
    <div className="flex flex-1 items-center justify-center p-8">
      <div className="max-w-[37.33rem] typography:prose">
        <h3 className="mb-3">Get started with your Inbox</h3>
        <VerticalStepper>
          <VerticalStepper.Step
            title="Forward your emails"
            icon="mail-01.3"
            colour="gray"
          >
            <p className="supporting-body text-gray-500 mb-3">
              Forward emails to your Payaca inbox, or add the Bcc address to
              automatically capture copies.
            </p>
            <div className="flex gap-2">
              <CopyAddressButton
                label="Forward address"
                icon="corner-up-right.3"
                address={addresses?.forwardAddress}
                tooltipText="Copy forward address"
              />
              <CopyAddressButton
                label="Bcc address"
                address={addresses?.copyAddress}
                tooltipText="Copy Bcc address"
              />
            </div>
          </VerticalStepper.Step>
          <VerticalStepper.Step
            title="Automatically assign"
            icon="link-04.3"
            colour="gray"
          >
            <p className="supporting-body text-gray-500">
              Emails from known Contacts are automatically matched and assigned
              to their Projects.
            </p>
          </VerticalStepper.Step>
          <VerticalStepper.Step
            title="Review and assign unmatched emails"
            icon="check-circle.3"
            colour="gray"
          >
            <p className="supporting-body text-gray-500">
              Any emails that can't be automatically matched will appear in your
              Unassigned tab for manual assignment.
            </p>
          </VerticalStepper.Step>
        </VerticalStepper>
      </div>
    </div>
  );
};

export default InboxEmptyState;
